export const libVersion = process.env.PKG_VERSION || 'local'; // processed by @rollup/plugin-replace
